import BasePainterTool from './BasePainterTool';
import TOOL_NAMES from './constants/toolNames';

export default class RepulserTool extends BasePainterTool {
  constructor(props = {}) {
    const defaultProps = { name: TOOL_NAMES.REPULSER_TOOL };
    const initialProps = Object.assign(defaultProps, props);
    super(initialProps, 'repulser');
  }
}
